import {useDispatch, useSelector} from "react-redux";
import {Listbox, Transition} from "@headlessui/react";
import {AppState} from "../../../../../stateManager/store";
import React, {Fragment, useEffect, useState} from "react";
import FixedColumnLeft from "../../../../../assets/svg/fixColumnLeft.svg";
import TextalignRight from "../../../../../assets/svg/textalign-right.svg";
import FixedColumnRight from "../../../../../assets/svg/fixColumnRight.svg";
import TextalignCenter from "../../../../../assets/svg/textalign-center.svg";
import {updateElement} from "../../../../../stateManager/store/formCreation_v2/actions";
import {ReactComponent as DropdownIcon} from "../../../../../assets/svg/solobuilder/dropdown.svg";

const FixedColumn = (props: any) => {
    const {selectedElementId, components} = useSelector((state: AppState) => state.formJson);
    const [ selectedAlignType, setSelectedAlignType ] = useState<any>("center");
    const [ selectedColType, setSelectedColType ] = useState<any>("left");
    const [ aligncolumnIds, setAlignColumnIds ] = useState<any>(null);
    const [ fixcolumnIds, setFixColumnIds ] = useState<any>(null);
    const config = components[ selectedElementId ]?.properties?.config || {};
    const templateSvgs = [ FixedColumnLeft, FixedColumnRight ]
    const alignmentIcons = [ TextalignCenter, TextalignRight ]
    const dispatch = useDispatch();
    const [ fixedColumns_Structure, setFixedColumns_Structure ] = useState<any>({
        "colLeft": [],
        "colRight": []
    })
    const [ alignmentType_structure, setAlignmentType_structure ] = useState<any>({
        "alignCenter": [],
        "alignRight": []
    })

    const handleChange = (path: any, value: any) => {
        dispatch(
            updateElement({
                id: selectedElementId,
                path,
                value,
            })
        );
    }

    const setFixedColum = () => {
        if (fixcolumnIds) {
            if (selectedColType === "left") {
                setFixedColumns_Structure({
                    ...fixedColumns_Structure,
                    colLeft: fixcolumnIds
                })
            } else {
                setFixedColumns_Structure({
                    ...fixedColumns_Structure,
                    colRight: fixcolumnIds
                })
            }
        }
    }

    const setAlignment = () => {
        if (aligncolumnIds) {
            if (selectedAlignType === "center") {
                setAlignmentType_structure({
                    ...alignmentType_structure,
                    alignCenter: aligncolumnIds,
                })
            } else if (selectedAlignType === "right") {
                setAlignmentType_structure({
                    ...alignmentType_structure,
                    alignRight: aligncolumnIds,
                })
            }
        }
    }

    useEffect(() => {
        if (alignmentType_structure?.alignRight?.length || alignmentType_structure?.alignCenter?.length) {
            handleChange("properties.config.alignmentType", alignmentType_structure)
        }
        if (fixedColumns_Structure?.colLeft?.length || fixedColumns_Structure?.colRight?.length) {
            handleChange("properties.config.fixedColType", fixedColumns_Structure)
        }
    }, [ fixedColumns_Structure, alignmentType_structure ])

    return (
        <div style={{marginTop: "10px", display: "flex", justifyContent: "space-between"}}>
            <div style={{
                display: "flex", alignItems: "center",
                fontWeight: 600, fontSize: "11px", color: "#282B31"
            }} >{props.label}</div>
            <div className="panel-input flex items-center justify-center">
                <div style={{width: "48px", borderRight: "1px solid rgba(125, 132, 146, 0.3)", height: "19px"}}>
                    <Listbox value="" onChange={(e) => false} >
                        <div className="relative">
                            <Listbox.Button className="relative flex items-center justify-between h-6 cursor-pointer bg-white outline-none" style={{width: "85%"}}>
                                {props.type === "dropDownInput_fixedCol" && <div>
                                    <img style={{top:0,left:0}} src={selectedColType === "left" ? FixedColumnLeft : FixedColumnRight} alt="fixedclmIcon" />
                                </div>}
                                {props.type === "dropDownInput_colAlign" && <div>
                                    <img height="14px" width="14px" style={{top:0,left:0}}
                                        src={selectedAlignType === "center" ? TextalignCenter : TextalignRight} alt="align-type" />
                                </div>}
                                <span className="">
                                    <DropdownIcon className="h-1.5 w-1.5 ml-2 text-gray-400" />
                                </span>
                            </Listbox.Button>
                            <Transition
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <Listbox.Options style={{width: "45px",marginLeft: "-5px", marginTop: "7px", border: "1px solid rgba(125, 132, 146, 0.294)", boxShadow: "rgba(125, 132, 146, 0.11) 0px 5px 8px"}} className="absolute z-50 overflow-auto rounded-md bg-white focus:outline-none">
                                    <div className="w-full flex flex-col items-center justify-center" style={{paddingBottom:"10px"}}>
                                        {props.type === "dropDownInput_fixedCol" ? templateSvgs && templateSvgs.map((items, i) => {
                                            return (
                                                <Listbox.Option key={i} value={items}
                                                    onClick={() => {
                                                        setFixColumnIds(null);
                                                        setSelectedColType(i === 0 ? "left" : "right");
                                                    }}
                                                    style={{margin: "10px 10px 0px"}}
                                                    className="flex flex-col items-center justify-center relative cursor-pointer select-none">
                                                    {({active}) => (
                                                        <div className="w-full">
                                                            <img height="14px" width="14px" style={{ filter: selectedColType===(i === 0 ? "left" : "right")||active?"invert(0.8) sepia(1.5) saturate(50) hue-rotate(10deg) brightness(1.04) contrast(1)":""}} src={items} alt="fixedclmIcon" />
                                                        </div>
                                                    )}
                                                </Listbox.Option>
                                            )
                                        }) : alignmentIcons && alignmentIcons.map((icons: any, i) => {
                                            return (
                                                <Listbox.Option key={i} value={icons}
                                                    onClick={() => {
                                                        setAlignColumnIds(null);
                                                        setSelectedAlignType(i === 0 ? "center" : "right");
                                                    }}
                                                    style={{margin: "10px 10px 0px"}}
                                                    className="flex flex-col items-center justify-center relative cursor-pointer select-none">
                                                    {({active}) => (
                                                        <div className="w-full">
                                                            <img height="14px" width="14px" style={{ filter: selectedAlignType===(i === 0 ? "center" : "right")||active?"invert(0.8) sepia(1.5) saturate(50) hue-rotate(10deg) brightness(1.04) contrast(1)":""}} src={icons} alt="align type" />
                                                        </div>
                                                    )}
                                                </Listbox.Option>
                                            )
                                        })
                                        }
                                    </div>
                                </Listbox.Options>
                            </Transition>
                        </div>
                    </Listbox>
                </div>
                {props.type === "dropDownInput_fixedCol" && <div style={{marginLeft: "11px"}}>
                    <input style={{outline: "none", width:"100%"}}
                        value={fixcolumnIds ||
                            (selectedColType === "left" && config?.fixedColType && config?.fixedColType?.colLeft.length > 0 && config?.fixedColType?.colLeft) ||
                            (selectedColType === "right" && config?.fixedColType && config?.fixedColType?.colRight.length > 0 && config?.fixedColType?.colRight) || ""
                        }
                        onBlur={(e: any) => {
                            setFixedColum();
                        }}
                        onChange={(e: any) => {
                            setFixColumnIds([ e.target.value ]);
                        }}
                        placeholder="eg: colid12, colid23,">
                    </input>
                </div>}
                {props.type === "dropDownInput_colAlign" && <div style={{marginLeft: "11px"}}>
                    <input style={{outline: "none", width:"100%"}}
                        value={aligncolumnIds ||
                            (selectedAlignType === "center" && config?.alignmentType?.alignCenter.length > 0 && config?.alignmentType?.alignCenter[ 0 ]) ||
                            (selectedAlignType === "right" && config?.alignmentType?.alignRight.length > 0 && config?.alignmentType?.alignRight[ 0 ]) || ""}
                        onBlur={(e: any) => {
                            setAlignment();
                        }}
                        onChange={(e: any) => {
                            setAlignColumnIds([ e.target.value ]);
                        }}
                        placeholder="eg: colid12, colid23,">
                    </input>
                </div>}
            </div>
        </div>
    )
}

export default FixedColumn;
